import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import '../App.css';
import TelevisionBreakpoint from "../components/responsive_utilities/television_breakpoint";
import DesktopBreakpoint from "../components/responsive_utilities/desktop_breakpoint";
import TabletBreakpoint from "../components/responsive_utilities/tablet_breakpoint";
import PhoneBreakpoint from "../components/responsive_utilities/phone_breakpoint";
import Dimensions from 'react-dimensions';
import ReactPlayer from 'react-player';
const sancoLogo = require('../media/fishntv_logo_white.png');

var firebase = require('firebase/app');
require('firebase/database');

class VideoPlayer extends Component {
  
  constructor() {
    super();
    this.state = {
      currentVideo: '',
			vidList: [],
      vidPlaying: true,
      width: 0,
      height: 0,
      redirect: false
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);  
		this.baseRef = firebase.database().ref('/');
  }
  
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener("keyup", this.keyHandling);
    this.baseRef.child('refresh').on('child_changed', this.reloadPage);
    this.baseRef.child('tournaments').on('child_changed', this.redirectToTournament);
		this.baseRef.child('refreshPlaylist').on('child_changed', this.reloadPlaylist);
		this.fetchVideosList();
		var fetchVids = setInterval(
			function() {
					this.fetchVideosList();
			}
			.bind(this),
			10800000
		);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener("keyup", this.keyHandling);
  }
	
	componentWillReceiveProps(newProps) {
		this.setState({channelAPI: newProps.channelAPI, channelID: newProps.channelID});
		this.fetchVideosList();
  }

  keyHandling = (e) => {
    if(e.keyCode === 179) {
      this.setState({
        vidPlaying: !this.state.vidPlaying
      })
    } else if(e.keyCode === 227) {
      this.previousVideo(this.state.currentVideo)
    } else if(e.keyCode === 228) {
      this.nextVideo(this.state.currentVideo)
    }  else {
      return
    }
  }
  
  redirectToTournament = (snapshot, last) => {
    console.log('Redirect Snap: ', snapshot.val())
    if(snapshot.val().activate && snapshot.val().href) {
      this.setState({
        redirect: true,
        redirectUrl: snapshot.val().href
      })
    }
  }
	
	reloadPage() {
    window.location.reload(true);
  }
	
	reloadPlaylist = () => {
		console.log('Reloading')
    this.fetchVideosList();
  }
	
	fetchVideosList() {
		const API = 'AIzaSyDPOAO90Hmjyg73TusAFE4-OfbaDIkfkwU';
		const channelID = 'PLBE2HTUQ9kZvSHNEPWDTEygVBsVI0WkKL';
		const results = 50;
		var vidList = [];
		
		var finalURL = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${channelID}&maxResults=${results}&key=${API}`;
		
		fetch(finalURL)
      .then((response) => response.json())
      .then((resp) => { 
				resp.items.forEach((item) => {
					vidList.unshift({
						url: 'https://youtu.be/' + item.snippet.resourceId.videoId,
						title: item.snippet.title,
						desc: item.snippet.description
					})
				})
				this.setState({
					vidList: vidList,
					currentVideo: vidList[0],
				})
      })
      .catch((error) => {
        console.error(error);
      });
	}
  
  keyHandling = (e) => {
    if(e.keyCode === 179) {
      this.setState({
        vidPlaying: !this.state.vidPlaying
      })
    } else if(e.keyCode === 227 || e.keyCode === 37) {
      this.previousVideo(this.state.currentVideo)
    } else if(e.keyCode === 228 || e.keyCode === 39) {
      this.nextVideo(this.state.currentVideo)
    }
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  
  nextVideo(currentVideo) {
    const videolist = this.state.vidList;
    var i = videolist.length - 1;
    var index = videolist.indexOf(currentVideo);
    if(index !== i) {
      var next = index + 1;
    } else {
      var next = 0;
    }
    this.setState({
      currentVideo: videolist[next]
    })
  }

  previousVideo(currentVideo) {
    const videolist = this.state.vidList;
    var i = videolist.length - 1;
    var index = videolist.indexOf(currentVideo);
    if(index !== i) {
      var previous = index - 1;
    } else {
      var previous = 0;
    }
    this.setState({
      currentVideo: videolist[previous]
    })
  }
  
  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirectUrl}/>;
  } 
		if(this.state.currentVideo.desc) {
			var currentVideoDesc = this.state.currentVideo.desc.slice(0, 50);
		}
		
    return (
      <div
        className='wrapper'
        width= {this.state.width}
        height= {this.state.height} >
			<TelevisionBreakpoint>
        <ReactPlayer 
          url={this.state.currentVideo.url}
          controls={true}
          width={this.state.width}
          height={this.state.height}
          preload={'true'}
          className='player'
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {
            this.nextVideo(this.state.currentVideo)
          }}
          playing={this.state.vidPlaying} />
          {this.state.currentVideo.title ? 
          <div className='overlay'>
            <div className='sancoLogo'>
              <img src={sancoLogo} height={90} width={200}/>
            </div>
          </div> : null }
				</TelevisionBreakpoint>
				<DesktopBreakpoint>
					<ReactPlayer 
          url={this.state.currentVideo.url}
          controls={true}
          width={this.state.width}
          height={this.state.height}
          className='player'
          preload={'true'}
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {
            this.nextVideo(this.state.currentVideo)
          }}
          playing={this.state.vidPlaying} />
          {this.state.currentVideo.title ? 
          <div className='overlayDesktop'>
            <div className='sancoLogoDesktop'>
              <img src={sancoLogo} height={50} width={100}/>
            </div>
          </div> : null }
				</DesktopBreakpoint>
				<TabletBreakpoint>
					<ReactPlayer 
          url={this.state.currentVideo.url}
          controls={true}
          width={this.state.width}
          height={this.state.height}
          className='player'
          preload={'true'}
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {
            this.nextVideo(this.state.currentVideo)
          }}
          playing={this.state.vidPlaying} />
          {this.state.currentVideo.title ? 
          <div className='overlayDesktop'>
            <div className='sancoLogoDesktop'>
              <img src={sancoLogo} height={75} width={150}/>
            </div>
          </div> : null }
				</TabletBreakpoint>
				<PhoneBreakpoint>
					<ReactPlayer 
          url={this.state.currentVideo.url}
          controls={true}
          width='100%'
          height={this.state.height}
          className='player'
          preload={'true'}
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {
            this.nextVideo(this.state.currentVideo)
          }}
          playing={this.state.vidPlaying} />
          <div className='overlayPhone'>
            <div className='sancoLogoPhone'>
              <img src={sancoLogo} height={60} width={120}/>
            </div>
          </div>
				</PhoneBreakpoint>
      </div>
    );
  }
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/pages/VideoPlayer.js